<template>
  <div
    v-if="curOrder"
    class="order-detail"
  >
    <div class="header">
      <CustomHeader
        :title="categoryName"
        :left-call-back="handleBack"
      />
    </div>
    <div class="main">
      <div class="info-wrap">
        <div class="package-info">
          <div class="package-title">
            套餐详情
          </div>
          <div
            v-for="(item, index) in equityShowList"
            :key="index"
            :class="['已用完', '已过期', '已退款'].includes(item.btnText) ? 'coupon-disabled' : ''"
            class="coupon"
          >
            <div
              v-if="item.appOnly"
              class="coupon-marker coupon-marker--app"
            >
              APP专享
            </div>
            <div
              v-else-if="[7,8].includes(item.couponType)"
              class="coupon-marker coupon-marker--app"
            >
              随机立减
            </div>
            <div
              v-else-if="item.isFreeGranted"
              class="coupon-marker coupon-marker--app"
            >
              免费加赠
            </div>
            <div
              v-if="item.propertyType === 5"
              class="coupon-left"
            >
              <img
                :src="item.iconUrl"
                alt="外部权益"
              >
            </div>
            <div
              v-else
              class="coupon-left coupon-text"
            >
              <div
                class="font-group"
              >
                <span
                  class="coupon-value"
                  :style="{
                    fontSize: `${
                      adjustedFontSize(
                        getDisplayValue(
                          item.couponType,
                          item.promoInterval,
                          item.couponLeft.num,
                        ),
                      )
                    }px`,
                    color: ['已用完', '已过期', '已退款'].includes(item.btnText) ? '#000' : '#ff5009',
                  }"
                >
                  {{ getDisplayValue(
                    item.couponType, item.promoInterval, item.couponLeft.num) }}
                </span>
                <span
                  class="coupon-worth"
                  :style="['已用完', '已过期', '已退款'].includes(item.btnText) ? 'color: #000' : '#ff5009'"
                >{{ item.couponLeft.word }}</span>
              </div>
            </div>
            <div class="coupon-center">
              <div class="coupon-center-inner">
                <div
                  class="coupon-center-name ellipsis-1"
                >
                  {{ item.virtualName }}
                </div>
                <div
                  class="coupon-center-desc ellipsis-1"
                >
                  {{ item.descList.join(" | ") }}
                </div>
              </div>
            </div>
            <div class="coupon-right">
              <div class="coupon-right-inner">
                <!-- 券数量 -->
                <!-- 待支付订单不会返回orderShowCouponStatus -->
                <div
                  v-if="item.displayCount || curOrder.orderStatus === 0"
                  class="coupon-num-container"
                >
                  <van-icon
                    class="coupon-num-icon"
                    name="cross"
                  />
                  <span class="coupon-num">{{ item.displayCount || item.virtualNum }}</span>
                  <span class="coupon-num-text">张</span>
                </div>
                <div
                  v-if="curOrder.orderStatus !== 0"
                  class="coupon-right-btn"
                  :style="
                    ['已用完', '已过期', '已退款'].includes(item.btnText) ? 'color: #000' : '#F41717'"
                  @click="btnClick(item)"
                >
                  {{ item.btnText }}
                </div>
              </div>
            </div>
          </div>
          <div class="use-notice">
            <div class="package-title">
              使用须知
            </div>
            <ExpandableText
              :content="useNotice"
              :max-lines="4"
              :line-height="18"
            />
          </div>
        </div>
      </div>
      <!-- 订单详情 -->
      <ul class="order-info">
        <li>
          <span>订单编号</span>
          <span>{{ curOrder.orderId }}</span>
        </li>
        <li v-if="curOrder.totalPromoAmount">
          <span>优惠金额</span>
          <span>{{ curOrder.totalPromoAmount }}元</span>
        </li>
        <li>
          <span>{{
            curOrder.payStatus === 0 || curOrder.payStatus === 3
              ? '待付金额'
              : '实付金额'
          }}</span><span>{{ curOrder.payPrice }}元</span>
        </li>
        <li><span>下单时间</span><span>{{ curOrder.orderTimeStr }}</span></li>
        <li v-if="goodsNum > 0">
          <span>购买数量</span>
          <span>{{ goodsNum }}</span>
        </li>
        <li v-if="curOrder.orderStatus === 0 || curOrder.orderStatus === 3">
          <span>过期时间</span><span>{{ curOrder.deadlineTimeStr }}</span>
        </li>
        <li v-if="curOrder.orderStatus === 2">
          <span>退款时间</span><span>{{ curOrder.refundTimeStr }}</span>
        </li>
        <li v-if="curOrder.remainNum > 0">
          <span>{{ getCouponTypeByStatus(curOrder.orderStatus) }}</span>
          <span>{{ curOrder.remainNumStr }}</span>
        </li>
      </ul>
      <div class="after-sale-btn">
        <div
          v-if="curOrder.orderCanRefund && hasOutJumpLink"
          class="refund-btn"
          @click="handleRefund"
        >
          申请退款
        </div>
        <div
          v-if="curOrder.orderCanRefund && showCsBtn && hasOutJumpLink"
          style="width: 0.01rem; height: 0.12rem; background: #666; margin-right: 0.12rem;"
        />
        <div
          v-if="showCsBtn"
          class="after-sale-btn-inner"
          @click="goAs"
        >
          <img
            src="https://m.hellobike.com/76d20121_icon_kefu%402x.png"
            class="icon"
          >
          <span>联系客服</span>
        </div>
      </div>
    </div>

    <div
      v-if="showWaitPayBtn"
      class="footer"
    >
      <div class="footer-actions">
        <div
          class="cancel-btn"
          @click="onCancelOrder"
        >
          取消订单
        </div>
        <div
          class="pay-wrap"
          @click="onBtnPay"
        >
          <div class="pay">
            <div class="pay-text">
              立即支付
            </div>
            <div class="pay-timer">
              {{ formattedTimer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { env, Native } from '@hb/mbridge';
import { mapState, mapActions } from 'vuex';
import qs from 'query-string';
import dayjs from 'dayjs';
import { Toast, Dialog } from 'vant';
// import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getCurEnvData,
  isAli,
  isAliMP,
  isEasyBikeApp,
  isHelloFamilyApp,
  isWeixin,
  getAppEnv,
} from '~mall/common/env/env';
import { appQueryConfig } from '~mall/common/utils/url';
import { timePad } from '~mall/common/utils/time';
import { actionRePay, reqMultiGoodsRepay } from '~mall/model/apis/order';
import {
  refundOrder, requestGetJumpLink, requestGetUseOutJumpLink, cancelOrder,
} from '~mall/model/apis/orderApis';
import { OrderShowCouponStatus } from '~mall/model/store/modules/ticket';
import { equityAdapter, equityGoUse } from '~mall/model/utils';
import Header from '~mall/components/Header.vue';
import { showThirdPage, showThirdPageOld, ticketResultPagejumpLink } from '~mall/common/utils/jumpUrl';
import JumpMarket from '~mall/common/utils/goMarketing';
import { uiMgr } from '~mall/common/uiMgr';
import { businessKeyBike, businessKeyEBike } from '~mall/common/utils/goMonthlyBike';
import NativeMgr from '~mall/common/native/native';
import {
  payWithSignNew, checkPayWithSignVersionCompatibility, PaymentType, getPaymentTypeByPayInfo,
} from '~mall/model/apis/pay';
// import { COUPON_MONTHLY_SCENE, PASSWORD_SCENE } from '@/common/constants/commonConstants';
import { safeJsonParse } from '~mall/common/utils';
import ExpandableText from '~mall/components/ExpandableText.vue';
import logger from '~mall/common/utils/logger';
import { tryShowWidgetGuide } from '~mall/common/utils/widgetGuide';
import setWrapperHeight from '~mall/common/utils/setWrapheight';
import { easyBikeAppDownLoadUrl, OrderStatus } from '../consts';

export default {
  name: 'OrderDetail',
  components: {
    CustomHeader: Header,
    ExpandableText,
  },
  data() {
    return {
      envData: getCurEnvData(),
      enableCustomService: isHelloFamilyApp || isAliMP,
      timerId: 0,
      timeLeft: 0,
      showWaitPayBtn: false,
    };
  },
  computed: {
    ...mapState('order', {
      curOrder: (state) => state.curOrder,
    }),
    equityShowList() {
      if (!this.curOrder) {
        return [];
      }

      const { totalVirtualList: goodsEquitys } = this.curOrder;

      if (!Array.isArray(goodsEquitys)) {
        return [];
      }

      return goodsEquitys.map((equity) => {
        const adaptedEquity = equityAdapter(equity);
        const { orderShowCouponStatus } = equity;
        let btnText = '';
        let couponTypeClass = '';
        let displayCount = 0;
        switch (orderShowCouponStatus) {
          case OrderShowCouponStatus.USE: {
            btnText = '去使用';
            couponTypeClass = 'use';
            displayCount = equity.remainNum;
            break;
          }
          case OrderShowCouponStatus.USED_UP: {
            btnText = '已用完';
            couponTypeClass = 'used';
            displayCount = equity.usedNum;
            break;
          }
          case OrderShowCouponStatus.OUTDATED: {
            btnText = '已过期';
            couponTypeClass = 'outdated';
            displayCount = equity.expiredNum;
            break;
          }
          case OrderShowCouponStatus.REFUNDED: {
            btnText = '已退款';
            couponTypeClass = 'refunded';
            displayCount = equity.virtualNum;
            break;
          }
          default:
            // noop
        }
        return {
          ...adaptedEquity,
          btnText,
          couponTypeClass,
          displayCount,
        };
      });
    },
    useNotice() {
      return this.curOrder ? this.curOrder.goodsList.map(({ useNotice }) => useNotice).join('') : '';
    },
    promoDescription() {
      return this.curOrder ? this.curOrder.goodsList.map(({ promoDescription }) => promoDescription).join('') : '';
    },
    usableRange() {
      return this.curOrder ? this.curOrder.goodsList.map(({ usableRange }) => usableRange).join('') : '';
    },
    goodsNum() {
      return this.curOrder?.goodsList?.reduce((acc, { num }) => acc + num, 0) || 0;
    },
    sharedUbtBizInfo() {
      if (!this.curOrder) {
        return null;
      }

      const {
        goodsList,
        orderStatus,
        orderId,
      } = this.curOrder;
      return {
        itemID: goodsList.map(({ spuId }) => spuId).join(','),
        businessType: goodsList.map(({ categoryId }) => categoryId).join(','),
        order_status: orderStatus,
        orderId,
      };
    },
    // 权益类型是否包含两轮卡， 退款跳转两轮页面
    hasRideCard() {
      return this.curOrder?.totalVirtualList?.some(({ virtualType }) => virtualType === 2);
    },
    // 两轮卡中包含骑行卡： 是否是单车
    isBike() {
      return this.curOrder?.totalCouponsList?.some(
        ({ businessKey }) => businessKeyBike.includes(businessKey),
      );
    },
    // 两轮卡中包含助力车卡：是否是助力车
    isEBike() {
      return this.curOrder?.totalCouponsList?.some(
        ({ businessKey }) => businessKeyEBike.includes(businessKey),
      );
    },

    // 包含外部券，不支持展示退款按钮
    hasOutJumpLink() {
      const isBikeOrEBike = this.curOrder?.goodsList?.some((goods) => ['103', '101'].includes(goods.categoryId));
      // 单车/助力车：不包含骑行卡时，但包含外部券->不展示按钮
      if (isBikeOrEBike) {
        return !(!this.hasRideCard
          && this.curOrder?.totalVirtualList?.some(({ propertyType }) => propertyType === 5));
      }
      // 其他业务线不影响
      return true;
    },

    showCsBtn() {
      return this.curOrder && this.curOrder.orderStatus !== 0 && this.enableCustomService;
    },
    categoryName() {
      return this.curOrder ? this.curOrder.goodsList[0].categoryName : '';
    },
    csUrl() {
      const type = (() => {
        switch (this.categoryName) {
          case '单车': {
            return 1;
          }
          case '顺风车': {
            return 7;
          }
          case '助力车': {
            return 2;
          }
          case '打车': {
            return 5;
          }
          case '电动车租赁': {
            return 4;
          }
          default:
            return undefined;
        }
      })();
      return `${this.envData.csUrl}?${qs.stringify({
        type,
        token: this.$store.state.user.userInfo.token,
      })}`;
    },
    formattedTimer() {
      if (this.timeLeft <= 0) {
        return '';
      }

      const minuteMillis = this.timeLeft % 864e5 % 36e5;
      const minutes = Math.floor(minuteMillis / 6e4);
      const seconds = Math.floor((minuteMillis % 6e4) / 1000);
      return `${timePad(minutes)}:${timePad(seconds)}`;
    },
  },
  watch: {
    curOrder: {
      handler() {
        if (!isHelloFamilyApp && this.curOrder) {
          Native.setPageTitle({
            title: this.categoryName,
          });
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.actionRequestBuyDetail(this.$route.params.orderId);
    await this.setShowWaitPayBtn();
    this.setupTimer();
    setWrapperHeight('order-detail');
    // UBTHelper.pageView({
    //   pageId: 'platform_couponMall_orderDetails',
    //   categoryId: 'platform',
    //   businessInfo: this.sharedUbtBizInfo,
    // });

    if (this.showCsBtn) {
      // UBTHelper.moduleExpose({
      //   pageId: 'platform_couponMall_orderDetails',
      //   categoryId: 'platform',
      //   moduleId: 'platform_couponMall_customerService_expose',
      //   contentId: 'platform_couponMall_customerService_expose',
      //   exposureTimes: 1,
      //   businessInfo: this.sharedUbtBizInfo,
      // });
    }

    if (this.curOrder?.orderCanRefund) {
      // UBTHelper.moduleExpose({
      //   pageId: 'platform_couponMall_orderDetails',
      //   categoryId: 'platform',
      //   moduleId: 'platform_couponMall_refund_expose',
      //   contentId: 'platform_couponMall_refund_expose',
      //   exposureTimes: 1,
      //   businessInfo: this.sharedUbtBizInfo,
      // });
    }

    // this.equityShowList.forEach(({ virtualId, btnText }) => {
    //   if (btnText === '去使用') {
    //     UBTHelper.moduleExpose({
    //       pageId: 'platform_couponMall_orderDetails',
    //       categoryId: 'platform',
    //       moduleId: 'platform_couponMall_use_expose',
    //       contentId: 'platform_couponMall_use_expose',
    //       exposureTimes: 1,
    //       businessInfo: {
    //         ...this.sharedUbtBizInfo,
    //         couponEquityId: virtualId,
    //       },
    //     });
    //   }
    // });
    if (isHelloFamilyApp) {
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBar',
        params: { isShowStatusBar: true },
      });
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBarColor',
        params: { isShowStatusBar: true, isDarkFont: false, colorCode: '#ffffff' },
      });
    }
  },
  beforeDestroy() {
    this.teardownTimer();
  },
  methods: {
    ...mapActions('order', {
      actionRequestBuyDetail: 'actionRequestBuyDetail',
      actionRequestBuyList: 'actionRequestBuyList',
    }),
    // 返回按钮点击：触发小组件引导后直接退出页面，不阻断
    handleBack() {
      const categoryId = this.curOrder ? this.curOrder.goodsList[0]?.categoryId : '';
      logger('[小组件引导] 订单详情页返回按钮触发引导categoryId:', categoryId);
      // 触发小组件引导（不等待结果，由客户端在页面退出后展示弹窗）
      tryShowWidgetGuide({ pageType: 'orderDetail', source: 'order_detail', categoryId });
      // 直接退出页面
      uiMgr.popPage();
    },
    /** 取消订单 */
    async onCancelOrder() {
      try {
        await Dialog.confirm({
          title: '是否确认取消订单？',
          confirmButtonText: '确定取消',
          cancelButtonText: '再想想',
          confirmButtonColor: '#FF5009',
          className: 'cancel-order-dialog',
        });
      } catch {
        return; // 用户点击"再想想"
      }

      const loading = Toast.loading({ message: '取消中...', duration: 0 });
      try {
        const res = await cancelOrder({
          orderId: this.curOrder.orderId,
          userNewId: window.$$user?.userNewId,
        });
        loading.clear();
        if (res.code === 0) {
          Toast('订单已取消');
          // 重新请求订单详情刷新页面状态
          await this.actionRequestBuyDetail(this.$route.params.orderId);
          await this.setShowWaitPayBtn();
        } else {
          Toast(res.msg || '取消失败');
        }
      } catch (error) {
        loading.clear();
        Toast('取消失败，请重试');
      }
    },
    async setShowWaitPayBtn() {
      const { version } = await NativeMgr.getDeviceInfo();
      const waitPayStatus = this.curOrder.orderStatus === 0;
      const waitPaySource = !this.curOrder.orderSource || this.curOrder.orderSource === 3;
      const payInfo = safeJsonParse(
        this.curOrder?.extra?.payInfo,
        {},
      );
      const paymentType = getPaymentTypeByPayInfo(payInfo);
      // const monthlyScene = this.order?.extra?.COUPON_MONTHLY_SCENE;
      // const passwordScene = this.curOrder?.extra?.PASSWORD_SCENE;

      // const isDyCard = monthlyScene === COUPON_MONTHLY_SCENE.DOUYIN_MONTHLY_PROPERTY;
      // const isAlipayMonthly = monthlyScene === COUPON_MONTHLY_SCENE.ALIPAY_MONTHLY_PROPERTY;
      // const isDouyinPassword = passwordScene === PASSWORD_SCENE.DOUYIN_PASSWORD_PROPERTY;
      // const isPayWithSignGoods = isDyCard || isDouyinPassword || isAlipayMonthly;

      // !! 如果paymentType新增类型和普通商品一样不走签约要处理这里增加判断条件
      if (paymentType !== PaymentType.NORMAL) {
        // 支付宝渠道支持 App 和支付宝小程序，抖音渠道只支持 App
        // 版本检查只在 App 环境下进行
        let shouldShowPayBtn = false;
        if (paymentType === PaymentType.ALIPAY_MONTHLY) {
          // 支付宝：App 需要版本检查，支付宝小程序不需要
          shouldShowPayBtn = env.isEasyBikeApp
            ? checkPayWithSignVersionCompatibility(version)
            : env.isAliMP;
        } else {
          // 抖音：只支持 App 且需要版本检查
          shouldShowPayBtn = env.isEasyBikeApp && checkPayWithSignVersionCompatibility(version);
        }
        this.showWaitPayBtn = waitPayStatus && waitPaySource && shouldShowPayBtn;
      } else {
        this.showWaitPayBtn = waitPayStatus && waitPaySource;
      }
    },
    truncateString(str, maxLength) {
      if (str.length <= maxLength) {
        return str;
      }
      return `${str.slice(0, maxLength)}...`;
    },
    adjustedScale(num, word, virtualNum) {
      const numLength = num.toString().length * 1.2;
      const wordLength = word.length * 0.8;
      const virtualNumLength = virtualNum.toString().length * 0.9;

      const totalWeightedLength = numLength + wordLength + virtualNumLength;
      if (totalWeightedLength < 5) {
        return 1.0;
      }

      const scaleFactor = 1.0 - (totalWeightedLength - 4) * 0.1;
      return Math.max(scaleFactor, 0.5);
    },
    async btnClick(equity) {
      if (equity.btnText !== '去使用') {
        return;
      }
      const categoryId = this.curOrder ? this.curOrder.goodsList[0].categoryId : '';
      if (equity.propertyType === 5) {
        if (categoryId) {
          const res = await requestGetUseOutJumpLink({ categoryId });
          let url = '';
          if (res) {
            if (isWeixin) {
              url = res.wxJumpUrlAfterPay;
            } else if (isAli) {
              url = res.aliPayJumpUrlAfterPay;
            } else {
              url = res.appJumpUrlAfterPay;
            }
            JumpMarket.goPage(url, true, false);
          }
        }
        return;
      }
      // UBTHelper.clickButton({
      //   pageId: 'platform_couponMall_orderDetails',
      //   buttonName: 'platform_couponMall_use_click',
      //   categoryId: 'platform',
      //   businessInfo: {
      //     ...this.sharedUbtBizInfo,
      //     couponEquityId: equity.virtualId,
      //   },
      // });

      if (appQueryConfig.activityId === 'MALL_ACT_23930') {
        // UBTHelper.clickButton({
        //   pageId: 'platform_930Holiday',
        //   buttonName: 'platform_930coupon_orderDetailsPage_use',
        //   categoryId: 'platform',
        //   businessInfo: {
        //     business: 'platform',
        //     source: appQueryConfig.adsource,
        //     componentType: '930coupon',
        //     couponEquityId: equity.virtualId,
        //     purchaseProductId: this.curOrder.goodsList.map(({ spuId }) => spuId).join(','),
        //   },
        // });
      }
      if (isEasyBikeApp) {
        equityGoUse(equity);
        return;
      }
      if (equity.appOnly && (env.isAliMP || env.isAliMPMonitor)) {
        showThirdPageOld(easyBikeAppDownLoadUrl);
        return;
      }
      if (categoryId) {
        const res = await requestGetJumpLink({ categoryId });
        if (!res) {
          uiMgr.replacePage('/bounty');
          return;
        }
        ticketResultPagejumpLink(res);
      }
    },
    getCouponTypeByStatus(status) {
      switch (status) {
        case OrderStatus.PAY:
          return '待支付';
        case OrderStatus.PAID:
          return '正常';
        case OrderStatus.REFUND:
          return '已退款';
        case OrderStatus.OUTDATE:
          return '已过期';
        case OrderStatus.ONGOING:
          return '进行中';
        case OrderStatus.FREEZE:
          return '冻结中，请联系客服';
        default:
          return '';
      }
    },
    getDisplayValue(couponType, promoInterval, num) {
      if ([7, 8].includes(couponType)) {
        if (promoInterval?.promoInfoList?.length) {
          const values = promoInterval.promoInfoList.map((item) => item.value);
          const minValue = Math.min(...values);
          const maxValue = Math.max(...values);
          return couponType === 7 ? `${minValue}-${maxValue}` : `${maxValue}-${minValue}`;
        }
        return '';
      }
      return num;
    },
    adjustedFontSize(value) {
      const numLength = value.toString().length;
      if (numLength < 4) {
        return 25;
      }
      const scaleFactor = Math.max(15, 25 - (numLength - 3) * 3);
      return scaleFactor;
    },
    adjustedTitleFontSize(value) {
      const numLength = value.toString().length;
      if (numLength < 8) {
        return 0.15;
      }
      return 0.12;
    },
    adjustedSubTitleFontSize(value) {
      const numLength = value.toString().length;
      if (numLength < 14) {
        return 0.12;
      }
      return 0.09;
    },
    activityId() {
      /** 优先使用链接上的activityId——应用内部跳转 */
      return this.$route.query.activityId || appQueryConfig.activityId;
    },
    sceneCode() {
      return this.$route.query.scene_code || appQueryConfig.scene_code;
    },
    subSceneCode() {
      return this.$route.query.sub_scene_code || appQueryConfig.sub_scene_code;
    },
    async onBtnPay() {
      logger('订单详情页立即支付：onBtnPay方法开始执行');
      const {
        goodsList,
        totalVirtualList,
        payOrder,
      } = this.curOrder;
      // UBTHelper.clickButton({
      //   pageId: 'mkt_couponmall_orderdetail',
      //   buttonName: 'mkt_couponmall_orderdetail_buynow',
      //   categoryId: 'market',
      //   businessInfo: {
      //     order_id: this.curOrder.orderId,
      //     coupon_itemid: goodsList.map(({ spuId }) => spuId).join(','),
      //     itemname: this.curOrder.showGoodsName,
      //     coupon_list: (totalVirtualList || []).map((item) => item.virtualName).join(','),
      //     origin_price: this.curOrder.totalOriginalPrice,
      //     sale_price: this.curOrder.totalSalePrice,
      //   },
      // });
      const payOrderInfo = payOrder;
      const goodsLen = goodsList.length;

      if (goodsLen === 0) {
        return;
      }
      const { version } = await NativeMgr.getDeviceInfo();
      const payInfo = safeJsonParse(
        this.curOrder?.extra?.payInfo,
        {},
      );
      const paymentType = getPaymentTypeByPayInfo(payInfo);
      // const monthlyScene = this.curOrder?.extra?.COUPON_MONTHLY_SCENE;
      // const passwordScene = this.curOrder?.extra?.PASSWORD_SCENE;

      // const isDyCard = monthlyScene === COUPON_MONTHLY_SCENE.DOUYIN_MONTHLY_PROPERTY;
      // const isAlipayMonthly = monthlyScene === COUPON_MONTHLY_SCENE.ALIPAY_MONTHLY_PROPERTY;
      // const isDouyinPassword = passwordScene === PASSWORD_SCENE.DOUYIN_PASSWORD_PROPERTY;
      // const isPayWithSignGoods = isDyCard || isDouyinPassword || isAlipayMonthly;

      // 支付宝渠道支持 App 和支付宝小程序，抖音渠道只支持 App
      // 版本检查只在 App 环境下进行
      let shouldShowPayWithSign = false;
      // !! 如果paymentType新增类型和普通商品一样不走签约要处理这里增加判断条件
      if (paymentType !== PaymentType.NORMAL) {
        if (paymentType === PaymentType.ALIPAY_MONTHLY) {
          // 支付宝：App 需要版本检查，支付宝小程序不需要
          shouldShowPayWithSign = env.isEasyBikeApp
            ? checkPayWithSignVersionCompatibility(version)
            : env.isAliMP;
        } else {
          // 抖音：只支持 App 且需要版本检查
          shouldShowPayWithSign = env.isEasyBikeApp
            && checkPayWithSignVersionCompatibility(version);
        }
      }

      if (shouldShowPayWithSign) {
        // 根据 extra 字段确定支付类型
        // let paymentType;
        // if (isDyCard) {
        //   paymentType = PaymentType.DOUYIN_MONTHLY;
        // } else if (isDouyinPassword) {
        //   paymentType = PaymentType.DOUYIN_PASSWORD_FREE;
        // } else if (isAlipayMonthly) {
        //   paymentType = PaymentType.ALIPAY_MONTHLY;
        // } else {
        //   paymentType = PaymentType.NORMAL;
        // }

        payWithSignNew({
          ...this.curOrder?.goodsList[0],
          payInfo,
          _priceInfo: {
            realPrice: this.curOrder.payPrice,
          },
        });
        return;
      }

      if (goodsLen === 1) {
        logger('订单详情页立即支付：goodsLen === 1，调用actionRePay方法');
        const [firstOrder] = goodsList;
        const { categoryId } = firstOrder;
        actionRePay({
          info: {
            payOrderInfo,
            categoryId,
            skuData: firstOrder,
          },
          successCallback: () => {
            // 支付成功刷新全部订单列表
            this.actionRequestBuyList({
              pageNum: 1,
              activityId: this.activityId,
              showStatus: 'all',
              sceneCode: this.sceneCode,
              subSceneCode: this.subSceneCode,
              filterClosedOrder: true,
            });
          },
        });
        return;
      }

      logger('订单详情页立即支付：goodsLen > 1，调用reqMultiGoodsRepay方法');
      reqMultiGoodsRepay(this.curOrder);
    },
    goAs() {
      const params = new URLSearchParams({
        csUrl: this.csUrl,
        orderCanRefund: this.curOrder.orderCanRefund ? '1' : '',
        showCsBtn: this.showCsBtn ? '1' : '',
        sharedUbtBizInfo: JSON.stringify(this.sharedUbtBizInfo),
      });
      uiMgr.pushPage(`orderAfterSale/${this.curOrder.orderId}?${params.toString()}`);
    },
    goCs() {
      // UBTHelper.clickButton({
      //   buttonName: 'APP_优惠券商城_购买记录详情页_联系客服',
      //   pageId: 'mkt_couponmall_orderdetail',
      //   categoryId: 'market',
      // });
      // UBTHelper.clickButton({
      //   pageId: 'platform_couponMall_orderDetails',
      //   buttonName: 'platform_couponMall_customerService_click',
      //   categoryId: 'platform',
      //   businessInfo: this.sharedUbtBizInfo,
      // });
      showThirdPage(this.csUrl);
    },
    // 申请退款
    async handleRefund() {
      // UBTHelper.clickButton({
      //   pageId: 'platform_couponMall_orderDetails',
      //   buttonName: 'platform_couponMall_refund_click',
      //   categoryId: 'platform',
      //   businessInfo: this.sharedUbtBizInfo,
      // });

      try {
        await Dialog.confirm({
          title: '确认退款',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonColor: '#08f',
        });
      } catch (error) {
        return;
      }

      // 如果是两轮权益卡的单车骑行卡和助力车骑行卡，需要跳转
      if (this.hasRideCard && (this.isBike || this.isEBike)) {
        const type = this.isBike ? 'bike' : 'evbike';
        const envPrefix = getAppEnv() === 'pro' ? '' : `${getAppEnv()}/`;
        const url = `https://m.hellobike.com/AppHelloBikeMainH5/${envPrefix}latest/index.html#/refund-ride-card?type=${type}&adSource=cshome`;
        // 所有端类型都包含的跳转方法
        showThirdPage(url);
        return;
      }

      // 正常退款流程：
      const loading = Toast.loading({
        message: '正在退款中',
        duration: 0,
      });
      logger('订单详情页申请退款：调用refundOrder方法');
      try {
        const res = await refundOrder({
          orderNo: this.curOrder.orderId,
        });
        loading.clear();
        logger('订单详情页申请退款：refundOrder接口调用完成', res);
        if (res.code === 0) {
          Toast({
            message: '退款申请成功，退款金额将原路返回',
            // duration: 5000,
          });
          setTimeout(() => {
            logger('退款成功，开始reload');
            // App WebView 环境下 reload() 可能不生效，改用 href 重新赋值
            const url = new URL(window.location.href);
            url.searchParams.set('_t', Date.now().toString());
            window.location.href = url.toString();
          }, 3000);
        } else {
          logger('退款失败：', res);
          Toast({
            message: res.msg || res.errMsg,
            duration: 3000,
          });
        }
      } catch (error) {
        logger('订单详情页申请退款：catch到异常', error);
        // noop
      }
    },
    startTimer(end) {
      return window.setTimeout(() => {
        const now = Date.now();

        if (now >= end) {
          this.timeLeft = 0;
          this.teardownTimer();
          window.location.reload();
        } else {
          this.timeLeft = end - now;
          this.timerId = this.startTimer(end);
        }
      }, 1000);
    },
    setupTimer() {
      const { deadlineTime: timeStr } = this.curOrder || {};

      if (timeStr) {
        const time = dayjs(timeStr).valueOf();
        this.timeLeft = Math.max(time - Date.now(), 0);

        if (this.timeLeft) {
          this.timerId = this.startTimer(time);
        }
      }
    },
    teardownTimer() {
      window.clearTimeout(this.timerId);
      this.timerId = 0;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/pages/mall/style/mixin.less';

.order-detail {
  display: -webkit-box;
  display: flex;
  display: flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  flex-direction: column;
  width: 100vw;
  height: 100%;
  overflow: auto;

  .main {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-box-flex: 1;
    flex: 1;
    width: 100%;
    background: #f5f5f5;

    .order-info {
      position: relative;
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 0 0.16rem;
      border-top: 0.1rem solid #f5f5f5;
      border-bottom: 0.1rem solid #f5f5f5;

      li {
        display: flex;
        justify-content: space-between;
        //0.5px的线需要改
        border-bottom: 0.005rem solid #f1f1f1;
        line-height: 0.5rem;

        :first-child {
          font-size: 0.14rem;
          font-weight: 400;
          color: rgba(51, 51, 51, 100%);
        }

        :last-child {
          font-size: 0.14rem;
          font-weight: 400;
          color: rgba(153, 153, 153, 100%);
        }
      }

      li:last-child {
        border: none;
      }
    }

    .after-sale-btn {
      display: flex;
      margin: 10px 0 30px;
      justify-content: center;
      align-items: center;
      color: #666;

      &-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        font-size: 14px;

        img {
          width: 12px;
          height: 8.8px;
          background-size: cover;
        }
      }

      .refund-btn {
        font-size: 0.14rem;
        color: #666;
        margin-right: 0.12rem;
      }
    }
  }

  .info-wrap {
    position: relative;
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: space-around;
    padding: 16px;

    /* Rectangle 143 */
    // width: 87%;
    // width: 85%;
    // height: 150px;
    background: #fff;
    // border-radius: 16px;

    .package-info {
      .coupon {
        display: flex;
        height: 72px;
        position: relative;
        background: url('https://m.hellobike.com/resource/gallery/421/JZ63v4Ibn3.png') no-repeat;
        background-size: 100%;
        align-items: center;
        box-sizing: border-box;
        margin-bottom: 0.14rem;

        &.coupon-disabled {
          display: flex;
          height: 72px;
          position: relative;
          background: url('https://m.hellobike.com/resource/gallery/421/EBG_4x10yA.png') no-repeat;
          background-size: 100%;
          align-items: center;
          box-sizing: border-box;
          margin-bottom: 0.14rem;
          border-radius: 0.12rem;
        }

        .coupon-marker {
          position: absolute;
          top: -5px;
          left: -4px;
          width: 56px;
          height: 15px;
          border-radius: 8px 0;
          font-family: PingFangTC-Semibold, "PingFang SC", sans-serif;
          font-size: 11px;
          line-height: 15px;
          text-align: center;
          color: #000;
          background: linear-gradient(to right, #ecff18, #a6ff00);
        }

        .coupon-left {
          padding: 16px 14px;
          flex-shrink: 0;
          display: flex;
          width: 81px;
          justify-content: center;
          align-items: center;
          color: #ff5009;

          img {
            width: 48px;
          }

          .font-group {
            display: flex;
            justify-content: center;
            align-items: flex-end;

            .coupon-value {
              font-size: 38px;
              line-height: 1;
              font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              font-weight: bold;
              white-space: nowrap;
              vertical-align: middle;

              &:empty {
                display: none;
              }
            }

            .coupon-worth {
              margin-left: 2px;
              font-size: 14px;
              font-family: PingFangSC-Semibold, "PingFang SC", sans-serif;
              font-weight: 600;

              &:empty {
                display: none;
              }
            }

            .num-group {
              display: flex;
              // justify-content: flex-end;
              align-items: flex-end;
              font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
              font-weight: 500;
              // line-height: 20px;
              .mul {
                font-size: 18px;
                margin: 0 3px;
                line-height: 20px;
              }

              .coupon-num {
                font-size: 22px;
                line-height: 22px;
              }

              .sheets {
                font-size: 14px;
              }
            }
          }
        }

        .coupon-center {
          width: 153px;
          display: flex;
          flex: 1;
          flex-direction: column;
          justify-content: center;
          text-align: left;

          .coupon-center-inner {
            padding-left: 0.16rem;
            display: flex;
            flex-direction: column;

            .coupon-center-name {
              font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
              font-size: 0.14rem;
              font-weight: 600;
              color: #000;
              line-height: 20px;
            }

            .ellipsis-1 {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .coupon-center-desc {
              font-size: 0.12rem;
              padding-right: 12px;
              font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
              line-height: 17px;
              font-weight: 400;
              color: #808080;
            }
          }
        }

        .coupon-right {
          width: 83px;
          box-sizing: border-box;
          display: flex;
          flex-shrink: 0;
          justify-content: center;
          align-items: center;
          padding: 11px 12px 11px 19px;

          .coupon-right-inner {
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .coupon-num-container {
              font-size: 12px;
              color: #fff;

              .coupon-num-icon {
                font-size: 12px;
                line-height: 0.24rem;
                vertical-align: baseline;
                padding-right: 0.02rem;
              }

              .coupon-num {
                font-size: 24px;
                font-weight: 700;
                color: #fff;
                vertical-align: baseline;
                font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              }

              .coupon-num-text {
                vertical-align: 1px;
              }
            }

            .coupon-right-btn {
              background: #fff;
              font-size: 12px;
              color: #f41717;
              border-radius: 0.16rem;
              padding: 0.02rem 0.08rem;
            }

            &-status {
              position: absolute;
              right: 5px;
              bottom: 8px;
              width: 80px;
            }
          }
        }
      }
    }

    .package-title {
      width: 100%;
      position: relative;
      padding-top: 0.12rem;
      margin-bottom: 0.12rem;
      font-size: 15px;
      font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 21px;
      z-index: 10;
    }

    .use-notice {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .good {
      margin: 0;
    }
  }

  .footer {
    background: #fff;

    .footer-actions {
      display: flex;
      align-items: center;
      padding: 0 0.16rem;
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
    }

    .cancel-btn {
      font-size: 14px;
      line-height: 20px;
      color: #5a6066;
      margin-right: 20px;
      padding-left: 8px;
    }

    .pay-wrap {
      flex: 1;
      min-width: 0;
      padding: 0.15rem 0;
      margin-top: 0.01rem;

      .pay {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 52px;
        margin: 0 auto;
        text-align: center;
        padding: 5px;
        width: 100%;
        box-sizing: border-box;
        background: linear-gradient(101.31deg, #ff744e 8.18%, #ff3b3f 38.64%, #ff3b3f 69.09%, #ff4ea7 89.73%);
        border-radius: 27px;
        color: rgba(255, 255, 255, 100%);

        &-text {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
        }

        &-timer {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #fff;
          opacity: 0.7;
          padding-left: 8px;
        }
      }
    }

    .footer-bottom {
      display: flex;
      justify-content: flex-end;
      padding: 16px;
    }

    .customer-service {
      margin-right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      // background: #F5F5F5;
      .icon {
        width: 0.12rem;
        height: 0.12rem;
      }

      span {
        padding-left: 0.04rem;
        font-size: 0.14rem;
        font-weight: 400;
        color: rgba(102, 102, 102, 100%);
        line-height: 0.2rem;
      }
    }
  }

  .footer-bottom {
    display: flex;
  }

  .refund {
    box-sizing: border-box;
    margin-right: 10px;
  }
}

@media only screen
  and (min-height: 800px)
  and (max-width: 375px)
  and (min-device-pixel-ratio: 2) {
  .footer {
    padding-bottom: 0.2rem;

    /* padding-top: 0.43rem; */
  }
}

@media only screen
  and (min-height: 890px)
  and (min-width: 414px)
  and (min-device-pixel-ratio: 2) {
  .footer {
    padding-bottom: 0.2rem;

    /* padding-top: 0.43rem; */
  }
}

.coupon-list {
  @border-radius: 4px;

  position: relative;
  border-radius: @border-radius;
  margin-top: 12px;

  .hairline(
    @border-color: #EEEEEE;
    @border-radius: @border-radius;
  );

  .coupon {
    position: relative;
    display: flex;
    align-items: stretch;
    height: 68px;

    &:first-child {
      &.coupon--btn .coupon-count {
        border-top-right-radius: @border-radius;
      }
    }

    &:not(:last-child) {
      .hairline(
        @border-color: #EEEEEE;
        @border-pos: bottom;
      );
    }

    .coupon-marker {
      position: absolute;
      top: 0;
      left: 0;
      width: 48px;
      height: 15px;
      border-radius: 4px 0;
      font-family: PingFangTC-Semibold, "PingFang SC", sans-serif;
      font-size: 11px;
      line-height: 15px;
      text-align: center;
      color: #fff;
      background-color: #ec5e40;
    }

    .coupon-head {
      flex: 1 1;
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .coupon-left {
      flex: 0 0 74px;
      margin: 0 4px;
      line-height: 1;
      text-align: center;
      color: #242729;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 48px;
      }

      .coupon-value {
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-size: 28px;
        font-weight: bold;
        line-height: 32px;
        vertical-align: -1px;

        &:empty {
          display: none;
        }
      }

      .coupon-worth {
        margin-left: 1px;
        font-size: 14px;
        font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
        font-weight: 500;

        &:empty {
          display: none;
        }
      }
    }

    .coupon-center {
      flex: 1;
      margin-right: 4px;
      overflow: hidden;
      text-align: left;

      .coupon-center-name {
        overflow: hidden;
        font-size: 14px;
        font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
        font-weight: 600;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #242729;
      }

      .coupon-center-desc {
        margin-top: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
        font-weight: 400;
        line-height: 1;
        color: #999;

        &:empty {
          display: none;
        }
      }
    }
  }

  .coupon.coupon--btn {
    .coupon-tail {
      position: relative;
    }

    .coupon-count {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 16px;
      border-radius: 0 0 0 4px;
      text-align: center;
      font-family: "PingFang SC", sans-serif;
      font-size: 11px;
      font-weight: 400;
      color: #373b3e;
      background: #eee;

      &::after {
        font-size: 11px;
        font-weight: 400;
        font-family: "PingFang SC", sans-serif;
      }
    }
  }

  .coupon.coupon--used {
    .coupon-btn {
      opacity: 0.4;
    }

    .coupon-count {
      opacity: 0.4;
    }
  }

  .coupon.coupon--outdated {
    // background-image: url(./images/coupon-bg-disabled.png);

    .coupon-btn {
      color: #fff;
      background: #d3dae0;

      &::after {
        display: none;
      }
    }

    .coupon-text {
      color: #bcc4cc;
    }

    .coupon-count {
      opacity: 0.4;
    }
  }
}
</style>

<!-- 取消订单弹窗样式（Dialog 挂载在 body，需非 scoped） -->
<style lang="less">
.cancel-order-dialog {
  width: 275px !important;
  border-radius: 20px !important;
  overflow: hidden;
  background: linear-gradient(180deg, #fff8d7 0%, #fff 30%, #fff 100%) !important;
  box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.7313) !important;
  padding: 30px 15px 22px !important;

  .van-dialog__header {
    padding: 0 0 24px;
    font-size: 20px;
    font-weight: 600;
    color: #242729;
    line-height: 28px;
  }

  .van-dialog__footer {
    padding: 0;
    display: flex;
    gap: 12px;

    // 重置 vant 按钮默认边框
    &::after {
      display: none !important;
    }

    .van-button {
      flex: 1;
      height: 40px;
      border-radius: 20px !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      border: none;

      &::before {
        display: none;
      }

      // 隐藏 vant hairline 边框
      &::after {
        display: none !important;
      }
    }

    .van-dialog__cancel {
      border: 0.5px solid #ff5526 !important;
      color: #ff5526 !important;
      background: transparent !important;

      .van-button__text {
        color: #ff5526;
      }
    }

    .van-dialog__confirm {
      background: #ff5526 !important;
      color: #fff !important;
      border: none !important;
      padding: 9px 24px;

      .van-button__text {
        color: #fff;
      }
    }
  }

  // 隐藏 vant 默认的 hairline 分割线
  .van-hairline--top::after,
  .van-hairline--left::after {
    display: none !important;
  }
}
</style>
